import {Component, Input, OnInit}
  from '@angular/core';
import {CommonModule} from '@angular/common';
import {TextToClipboard} from "../helpers";

@Component({
  selector: 'clipboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clipboard.component.html',
  styleUrls: ['./clipboard.component.scss']
})
export class ClipboardComponent implements OnInit {
  constructor() {
  }

  @Input() value = "";
  @Input() show = false;
  copied = false;

  ngOnInit(): void {
  }

  copy() {
    TextToClipboard(this.value);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 1000);
  }

}
